// Data extracted from the "Hayat Infotech" portfolio zip.
// Kept as a plain data module so it stays easy to update from admin later.
export const infotech = {
  company: {
    name: "Hayat Infotech",
    tagline: "Software house · Web systems",
    phoneDisplay: "+91 96738 78652",
    phoneDial: "+919673878652",
    whatsapp: "https://wa.me/919673878652",
  },
  capabilities: [
    {
      key: "management",
      title: "Management systems",
      body: "Members, records, approvals and day-to-day administration for community bodies and businesses — one system instead of a dozen spreadsheets.",
    },
    {
      key: "events",
      title: "Event & seating operations",
      body: "Registration, passes and seat allocation for gatherings that run to a schedule and fill a hall.",
    },
    {
      key: "streaming",
      title: "Live streaming",
      body: "Programmes streamed to a known audience from inside the same platform that manages them.",
    },
    {
      key: "web",
      title: "Business websites",
      body: "Company and product sites for manufacturing, security and trade — built to be found, read and acted on.",
    },
  ],
  projects: [
    {
      domain: "smngp.com",
      href: "https://www.smngp.com",
      name: "SMNGP",
      tagline: "Dawoodi Bohra Jamaat Management System",
      body: "The flagship platform — member records, jamaat administration and day-to-day operations in one place.",
      tag: "Community",
      modules: [
        {
          domain: "smngp.com/live",
          href: "https://www.smngp.com/live",
          name: "Live Streaming Software",
          body: "Streams programmes to members from inside the platform.",
        },
        {
          domain: "smngp.com/seat",
          href: "https://www.smngp.com/seat",
          name: "Seat Management System",
          body: "Seat allocation and hall planning for large gatherings.",
        },
      ],
    },
    {
      domain: "nagpurjamaat.in",
      href: "https://www.nagpurjamaat.in",
      name: "Nagpur Jamaat",
      tagline: "Nagpur Dawoodi Bohra Jamaat Management Software",
      body: "Jamaat management software for the Nagpur Dawoodi Bohra community.",
      tag: "Community",
      modules: [],
    },
    {
      domain: "asharaams.com",
      href: "https://www.asharaams.com",
      name: "Ashara AMS",
      tagline: "Ashara Management System",
      body: "Runs the logistics of the annual ten-day Ashara gathering end to end.",
      tag: "Events",
      modules: [],
    },
    {
      domain: "hayatcctv.in",
      href: "https://www.hayatcctv.in",
      name: "Hayat CCTV Manager",
      tagline: "CCTV Management System",
      body: "Keeps installations, devices, customers and service history on record for a security operation.",
      tag: "Security",
      modules: [],
    },
    {
      domain: "roarexpo.com",
      href: "https://www.roarexpo.com",
      name: "ROAR Expo",
      tagline: "Business expo website & registration",
      body: "Public site and registration flow for the ROAR business expo.",
      tag: "Events",
      modules: [],
    },
    {
      domain: "khayyatalalbabji.com",
      href: "https://www.khayyatalalbabji.com",
      name: "Khayyat Al Albabji",
      tagline: "Cloth manufacturing firm, Kuwait",
      body: "Company website for a Kuwait-based cloth manufacturer.",
      tag: "Trade",
      modules: [],
    },
    {
      domain: "hayatcctv.com",
      href: "https://www.hayatcctv.com",
      name: "Hayat CCTV",
      tagline: "CCTV company website",
      body: "Product and company site for the CCTV business.",
      tag: "Security",
      modules: [],
    },
  ],
};
